const KEY = "me_ref_code";

export function saveRefFromUrl() {
  const url = new URL(window.location.href);
  const code = url.searchParams.get("ref");
  if (!code) return;

  if (!localStorage.getItem(KEY)) {
    localStorage.setItem(KEY, code.trim());
  }

  url.searchParams.delete("ref");
  window.history.replaceState({}, "", url.toString());
}